<template>
    <div id="app">
        <my-header v-if="auth.permission === $route.meta.permission && !$route.meta.error && !$route.meta.classRoom" ref="header"></my-header>
        <div class="container-fluid">
        	<div class="row">
                <my-menu class="col pl-0 pr-0" v-if="auth.permission === $route.meta.permission && !$route.meta.error && !$route.meta.classRoom && !statusFormats" ref="menu"></my-menu>
                <div class="blurcolor-menu d-block d-lg-none" v-if="menu.showMenuResponsive" @click="setStatusMenuResponsive(false)"></div>
        		<router-view class="col" 
                             :class="{ 'view p-4': auth.permission === $route.meta.permission && !$route.meta.classRoom && !$route.meta.error, compact: menu.compact }"
                             :style="{ marginLeft: merginLeft }"
                             ref="content"/>
        	</div>
        </div>
        <vue-progress-bar></vue-progress-bar>   
        <!-- Float button -->
        <v-modal-ongoing-lesson v-if="auth.permission === $route.meta.permission && !$route.meta.error && !$route.meta.classRoom"/>
        <!-- All modals -->
        <component :is="modalVal.modal" :key="modalVal.type || 'modal'" v-if="modalVal.modal != 'close' && modalVal.modal != 'leaveRoom'"></component>
        <!-- Modal notification permissions -->
        <v-push-notifications v-if="auth.permission === $route.meta.permission && $firebase.messaging"/>
        <!-- Notifications -->
        <v-notification :style="{ bottom: statusOngoingLesson && !$route.meta.classRoom?'120px':'20px' }"/>
    </div>
</template>

<script type="text/javascript">
    import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
    export default{
        metaInfo(){
            return {
                title: this.title,
                htmlAttrs: {
                    lang: this.i18n.locale
                }
            }
        },
        computed:{
            ...mapState(['auth','title','menu','i18n','currentLesson', 'statusOngoingLesson', 'grid']),
            ...mapGetters(['events', 'modalVal', 'statusFormats', 'permissionFormats']),
            merginLeft(){
                if(this.statusFormats && this.permissionFormats && this.auth.permission == 'student')
                   return '0px';
                
                return null;
            }
        },
        methods:{
            ...mapMutations(['setInstitution','setStatusMenuResponsive','changeTitle', 'setpendingFeedback','setpendingConfirmation','setIsMovile', 'setNotification', 'setModal', 'setActiveLessons', 'handleGrid', 'handleSize']),
            ...mapActions(['handleLang', 'beforeShowModal','getLesson', 'getLessonById','lessonsFeedback', 'getBrowserData', 'axiosRequest', 'saveLang']),
            isMovile(){
                let check = false;
                ((a) => {if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                this.setIsMovile(check);
            },
            getGrid(){
                const w = window.innerWidth,
                      h = window.innerHeight;

                if(w >= 1200 && this.grid != 'xl')
                    this.handleGrid('xl');
                else if(w < 1200 && w >= 992 && this.grid != 'lg')
                    this.handleGrid('lg');
                else if(w < 992 && w >= 768 && this.grid != 'md')
                    this.handleGrid('md');
                else if(w < 768 && w >= 576 && this.grid != 'sm')
                    this.handleGrid('sm');
                else if(w < 576 && this.grid != 'xs')
                    this.handleGrid('xs');

                this.handleSize({ headerH: this.$refs.header?this.$refs.header.$el.offsetHeight:null, windowH:h });
            }
        },
        created(){
            // Set browser language
            let ln =  '';
            if (this.$localStorage.get('appLang'))
                ln = this.$localStorage.get('appLang');
            else 
                ln = (navigator.language || navigator.userLanguage || navigator.browserLanguage);

            this.handleLang(ln);

             // Set progress bar color
            if (this.auth.permission === 'tutor' | this.auth.permission == '')
                this.$Progress.setColor('#00C0ff');
            else
                this.$Progress.setColor('#72BD00');

            // is movile
            this.isMovile();

            // Browser
            this.getBrowserData();
        },
        mounted(){
            window.addEventListener('resize', this.getGrid);
            this.getGrid();
            this.$watch('isOnline', newVal => { // watch if the internet come back 
                if (newVal){
                    this.setNotification({ type: "success", closeNE: true, msg: this.$t('msgOnline') });
                }
            });
        },
        watch:{
            isOffline: function(newVal){ // watch if the internet lost
                if (newVal)
                    this.setNotification({ type: "error", noClose:true, msg: this.$t('msgOffline') });
            },
            'auth.permission': function(newVal){
                if (newVal === 'tutor'){
                    this.$Progress.setColor('#00C0ff');
                    this.lessonsFeedback();
                }
                else if(newVal === 'student'){
                    this.$Progress.setColor('#72BD00');
                    this.lessonsFeedback();
                }
                else{
                    this.$Progress.setColor('#72BD00');
                }
            },
            '$route.meta.title': function(newVal) {
                if (newVal)
                    if (newVal!==this.title)
                        this.changeTitle(this.$t(newVal));
            },
            'i18n.locale': function(newVal,oldVal){
                this.$localStorage.set('appLang', newVal);
                if (oldVal && this.auth.token !== '')
                        this.saveLang(newVal);
                if (this.$route.meta.title)
                    this.changeTitle(this.$t(this.$route.meta.title));
            },
            events: {
                handler: function(newVal, oldVal) {
                    this.$nextTick(() => {
                        const lesson = JSON.parse(this.$localStorage.get('lesson'));
                        console.log(newVal);
                        if (newVal && lesson)
                            if (lesson.lesson != newVal) {
                                const lesson = newVal.split('_');
                                if (lesson[1] === 'pendingAccept' && oldVal){
                                    const newArray = this.auth.pendingConfirmation;
                                    newArray.unshift({ id: lesson[0] })
                                    this.setpendingConfirmation(newArray);   
                                    this.beforeShowModal({ lesson: { id: lesson[0] }, action: 'v-modal-crud:confirmLesson' });
                                }
                                else if(lesson[1] === 'ongoing' && oldVal){
                                    this.getLessonById(lesson[0]).then( data => {
                                        if (data[0].status == 'Activa') {
                                            let activeLessons = this.auth.activeLessons;
                                            activeLessons.push(data[0]);
                                            this.setActiveLessons(activeLessons);
                                        }

                                        if (data[0].modality === "Online" && data[0].status == 'Activa'){
                                            if (this.auth.permission === 'student')
                                                this.beforeShowModal({ lesson: data[0], action: 'v-join-onboarding' });
                                            else if(this.auth.permission === 'tutor' && data[0].type == 'Individual')
                                                this.$router.push({ name: `room-${this.auth.permission}`, params: { roomId: data[0].id } });
                                        }
                                        else if(this.modalVal.type == 'start' && this.currentLesson.lesson.id+'' === lesson[0]){
                                            this.setModal('');
                                        }

                                        if (this.currentLesson.lesson.id+'' === lesson[0] && this.modalVal.type == 'confirmLesson'){
                                            this.setModal('');
                                        }
                                    } )
                                }
                                else if(lesson[1] === "changedPlace" && this.auth.currentActiveLesson){
                                    let activeLessons = this.auth.activeLessons;
                                    const index = activeLessons.findIndex( item => item.id+'' == lesson[0] );
                                    
                                    if (index >= 0) {
                                        this.getLessonById(lesson[0]).then( data => {
                                            activeLessons[index] = data[0];
                                            this.setActiveLessons(activeLessons);
                                        });
                                    }
                                }
                                else if(lesson[1] === 'pendingFeedback' && oldVal){
                                    const newArray = this.auth.pendingFeedback;
                                    newArray.unshift({ id: lesson[0] })
                                    this.setpendingFeedback(newArray);
                                    if (this.auth.pendingConfirmation.length === 0)
                                        this.getLesson(newArray[0].id);
                                }
                                else if(this.currentLesson.lesson && this.modalVal.modal != ''){
                                    if(this.auth.pendingConfirmation.find( i => i.id+'' == lesson[0] ) && lesson[1] == 'canceled'){
                                        const newArray = this.auth.pendingConfirmation.filter( i => i.id+'' !== lesson[0] );
                                        this.setpendingConfirmation(newArray);
                                        if (this.modalVal.type == 'confirmLesson') 
                                            this.setModal('');
                                    }
                                    else if (this.currentLesson.lesson.id+'' === lesson[0]){
                                        console.log('ejem,', lesson[1]);
                                        if ((this.modalVal.type == 'cancel' && lesson[1] == 'canceled') || (this.modalVal.type == 'confirm' && lesson[1] == 'upcoming') || (this.modalVal.type == 'confirmLesson' && lesson[1] == 'requestRejected') || (this.modalVal.type == 'confirm' && lesson[1] == 'canceled') || (this.modalVal.type == 'start' && lesson[1] == 'canceled') || (this.modalVal.modal == 'v-join-onboarding' && lesson[1] != 'userGroupJoined')) 
                                            this.setModal('');
                                    }
                                }
                            }
                        this.$localStorage.set('lesson',JSON.stringify({ lesson: newVal }));
                    })    
                },
                deep: true
            }
        }
    }
</script>
